// src/pages/Home.jsx
import React from "react";
import { Link } from "react-router-dom";
import CarouselSection from "../components/CarouselSection";
import FadeInOnScroll from "../components/FadeInOnScroll";
import c5Image from "../assets/c5.jpg";
import gallery1 from "../assets/1.jpg";
import gallery2 from "../assets/2.jpg";
import gallery3 from "../assets/3.jpg";
import gallery4 from "../assets/4.jpg";
import gallery5 from "../assets/5.jpg";
import gallery6 from "../assets/6.jpg";
import gallery7 from "../assets/7.jpg";
import gallery8 from "../assets/8.jpg";
import gallery9 from "../assets/9.jpg";
import gallery10 from "../assets/10.jpg";
import gallery11 from "../assets/11.jpeg";

if (!document.getElementById("home-fonts")) {
  const l = document.createElement("link");
  l.id = "home-fonts"; l.rel = "stylesheet";
  l.href = "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400&family=Raleway:wght@400;500;600;700&display=swap";
  document.head.appendChild(l);
}

const demoAnnouncements = [
  { title: "Christmas Carol Service", date: "Dec 24", text: "Join us at 7 PM for carols and refreshments." },
  { title: "Food Drive", date: "Dec 10", text: "Bring non-perishable items to the parish hall." },
];

function SplitPillButton({ href, to, label, icon, color = "amber" }) {
  const colorSchemes = {
    amber: {
      bg: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
      hover: "linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)",
      iconBg: "#fffbeb",
      iconBgHover: "#f59e0b",
      iconColor: "#d97706",
      shadow: "rgba(245, 158, 11, 0.4)"
    },
    orange: {
      bg: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
      hover: "linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)",
      iconBg: "#fffbeb",
      iconBgHover: "#f59e0b",
      iconColor: "#d97706",
      shadow: "rgba(245, 158, 11, 0.4)"
    }
  };

  const scheme = colorSchemes[color];

  const Tag = to ? Link : "a";
  const tagProps = to ? { to } : { href: href || "#" };

  return (
    <Tag
      {...tagProps}
      className="relative inline-block group focus:outline-none button-3d-hover"
      aria-label={label}
      style={{ textDecoration: "none" }}
    >
      <span
        className="absolute inset-0 rounded-xl transition-all duration-200 stack-layer-1"
        style={{
          background: "#1f2937",
          transform: "translateY(8px)",
          zIndex: 0,
        }}
      />
      <span
        className="absolute inset-0 rounded-xl transition-all duration-200 stack-layer-2"
        style={{
          background: "#374151",
          transform: "translateY(4px)",
          zIndex: 1,
        }}
      />

      <span
        className="relative flex items-stretch rounded-xl overflow-hidden transition-all duration-200 main-button"
        style={{
          zIndex: 2,
          boxShadow: "0 8px 20px rgba(0, 0, 0, 0.3), 0 4px 10px rgba(0, 0, 0, 0.2)",
        }}
      >
        <span
          className="flex items-center justify-center shrink-0 icon-block"
          style={{
            width: 70,
            height: 60,
            background: scheme.iconBg,
            color: scheme.iconColor,
            borderTopLeftRadius: 12,
            borderBottomLeftRadius: 12,
            transition: "all 200ms ease",
          }}
        >
          {icon}
        </span>

        <span
          className="flex items-center button-label"
          style={{
            padding: "0 1.5rem",
            background: scheme.bg,
            color: "#92400e",
            borderTopRightRadius: 12,
            borderBottomRightRadius: 12,
            fontWeight: 700,
            letterSpacing: "0.05em",
            minWidth: 240,
            transition: "all 200ms ease",
          }}
        >
          <span style={{ fontSize: "0.95rem" }}>{label}</span>
        </span>
      </span>

      <style jsx>{`
        .button-3d-hover:hover .stack-layer-1 {
          transform: translateY(2px) !important;
        }
        .button-3d-hover:hover .stack-layer-2 {
          transform: translateY(1px) !important;
        }
        .button-3d-hover:hover .main-button {
          transform: translateY(-6px) !important;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4), 0 10px 25px rgba(0, 0, 0, 0.3) !important;
        }
        .button-3d-hover:hover .button-label {
          background: ${scheme.hover} !important;
          color: white !important;
        }
        .button-3d-hover:hover .icon-block {
          background: #fbbf24 !important;
          color: white !important;
        }
      `}</style>
    </Tag>
  );
}

export default function Home() {
  return (
    <main className="pt-0 relative min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-amber-100">
      <style jsx>{`
        @keyframes gradient {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        .animate-gradient { background-size: 200% auto; animation: gradient 3s ease infinite; }
        .bg-300 { background-size: 300% auto; }
        .animate-gradient-text { filter: drop-shadow(0 0 20px rgba(217, 119, 6, 0.2)); }
        .section-panel {
          background: linear-gradient(180deg, rgba(255, 250, 238, 0.48), rgba(255, 244, 229, 0.36));
          border-radius: 1.25rem;
          backdrop-filter: blur(6px);
          -webkit-backdrop-filter: blur(6px);
          box-shadow: 0 10px 30px rgba(0,0,0,0.08), 0 20px 60px rgba(217,119,6,0.12), 0 4px 15px rgba(0,0,0,0.06);
        }
        .section-panel p, .section-panel h2 { color: rgba(17, 24, 39, 0.95); }
        .enhanced-card {
          box-shadow: 0 10px 30px rgba(0,0,0,0.1), 0 20px 60px rgba(217,119,6,0.15), 0 4px 15px rgba(0,0,0,0.08), inset 0 1px 0 rgba(255,255,255,0.5);
          transition: all 0.3s ease;
        }
        .enhanced-card:hover {
          box-shadow: 0 15px 40px rgba(0,0,0,0.12), 0 25px 70px rgba(217,119,6,0.2), 0 6px 20px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.6);
          transform: translateY(-4px);
        }
        .maroon-text { color: #5b1d1b; }
        .maroon-lead { color: #5b1d1b; font-weight: 600; }
      `}</style>

      {/* IMAGE CAROUSEL */}
      <section className="relative w-full">
        <CarouselSection />
      </section>

      {/* HERO SECTION */}
      <section className="relative text-center py-24 md:py-40 overflow-visible">
        <div className="relative z-10 max-w-5xl mx-auto px-6">
          <FadeInOnScroll distance={60} duration={950} delay={80}>
            <div className="mb-20">
              <h1 style={{
                fontFamily:"'Cormorant Garamond',Georgia,serif",
                fontSize:"clamp(38px,6vw,72px)",
                fontWeight:700,
                color:"#7c2d12",
                lineHeight:1.05,
                letterSpacing:"-0.5px",
                margin:"0 0 16px",
              }}>
                Welcome to St. Stephen's
              </h1>
              <div style={{ width:56, height:2, background:"linear-gradient(to right,#92400e,#d97706,transparent)", borderRadius:2, margin:"0 auto" }} />
            </div>

            <div className="mt-8 mb-6 flex justify-center">
              <div className="rounded-xl p-1 bg-gradient-to-r from-amber-200/60 to-orange-200/60 inline-block">
                <img
                  src={c5Image}
                  alt="Church decoration"
                  className="w-full max-w-3xl h-48 md:h-56 lg:h-64 object-cover rounded-lg shadow-2xl ring-2 ring-amber-100 hover:scale-105 transform transition-transform duration-300"
                />
              </div>
            </div>

            <div className="mt-4 max-w-2xl mx-auto">
              <p className="text-base italic maroon-text">
                "Remember when you forgive you heal and when you let go you grow."
              </p>
            </div>

            <div className="mt-12 flex flex-col sm:flex-row justify-center items-center gap-8">
              <SplitPillButton
                href="#annmassbuttons"
                label="MASS TIMINGS"
                color="amber"
                icon={
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 2v20" /><path d="M5 9h14" />
                  </svg>
                }
              />
              <SplitPillButton
                to="/announcements"
                label="ANNOUNCEMENTS"
                color="orange"
                icon={
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
                    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
                  </svg>
                }
              />
            </div>
          </FadeInOnScroll>
        </div>
      </section>

      {/* ABOUT US SECTION */}
      <section className="relative py-16 overflow-hidden">
        <div className="absolute -top-20 -right-20 w-80 h-80 bg-gradient-to-bl from-amber-100/60 to-orange-200/60 rounded-full blur-3xl" />
        <div className="absolute -bottom-20 -left-20 w-80 h-80 bg-gradient-to-tr from-yellow-300/20 to-amber-400/15 rounded-full blur-3xl" />

        <div className="max-w-6xl mx-auto px-3 md:px-6 relative z-10">
          <FadeInOnScroll distance={40} duration={950} delay={80}>
            <div style={{ textAlign:"center", marginBottom:32 }}>
              <h2 style={{ fontFamily:"'Cormorant Garamond',Georgia,serif", fontSize:"clamp(28px,4vw,48px)", fontWeight:700, color:"#7c2d12", margin:"0 0 12px", lineHeight:1.1, letterSpacing:"-0.3px" }}>
                About Us
              </h2>
              <div style={{ width:40, height:2, background:"linear-gradient(to right,#92400e,#d97706,transparent)", borderRadius:2, margin:"0 auto" }} />
            </div>

            <div className="section-panel p-4 md:p-8 lg:p-12">
              <p style={{ fontFamily:"'Cormorant Garamond',Georgia,serif", fontSize:19, color:"#5b1d1b", lineHeight:1.8, marginBottom:24, textAlign:"left" }}>
                St. Stephen's Church has been a beacon of faith in Cumballa Hill since 1941. What began as a private residence where Catholics gathered for prayer has blossomed into a vibrant parish community. Our church was officially established on September 5, 1941, and formally erected as a parish on December 26, 1948, the Feast of St. Stephen.
              </p>
              <p style={{ fontFamily:"'Cormorant Garamond',Georgia,serif", fontSize:19, color:"#5b1d1b", lineHeight:1.8, marginBottom:24, textAlign:"left" }}>
                The present church building, opened in 1966, stands as a remarkable example of Art Deco and modernist architecture. Designed by Perin J. Mistri, India's first qualified woman architect, our distinctive white concave tower with its crucifix has become an iconic landmark in Mumbai.
              </p>
              <p style={{ fontFamily:"'Cormorant Garamond',Georgia,serif", fontSize:19, color:"#5b1d1b", lineHeight:1.8, marginBottom:32, textAlign:"left" }}>
                Today, St. Stephen's continues to serve a thriving Catholic community, offering multiple daily Masses in English, Konkani, and Hindi. We are more than just a place of worship—we are a family united in faith, hope, and love.
              </p>
              <div className="flex justify-center">
                <Link
                  to="/history"
                  className="inline-flex items-center gap-3 bg-gradient-to-r from-amber-500 to-orange-500 text-white font-bold px-8 py-4 rounded-xl shadow-lg hover:shadow-2xl hover:from-amber-600 hover:to-orange-600 transition-all duration-300 transform hover:-translate-y-1"
                >
                  <span>Know More About Our History</span>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12h14" /><path d="m12 5 7 7-7 7" />
                  </svg>
                </Link>
              </div>
            </div>
          </FadeInOnScroll>
        </div>
      </section>

      {/* GALLERY SECTION */}
      <section className="relative py-16 overflow-hidden">
        <div className="absolute top-20 left-10 w-96 h-96 bg-gradient-to-br from-amber-300/15 to-orange-400/10 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-gradient-to-tl from-yellow-300/15 to-amber-400/10 rounded-full blur-3xl" />

        <div className="max-w-7xl mx-auto px-3 md:px-6 relative z-10">
          <FadeInOnScroll distance={40} duration={950} delay={80}>
            <div style={{ textAlign:"center", marginBottom:32 }}>
              <h2 style={{ fontFamily:"'Cormorant Garamond',Georgia,serif", fontSize:"clamp(28px,4vw,48px)", fontWeight:700, color:"#7c2d12", margin:"0 0 12px", lineHeight:1.1, letterSpacing:"-0.3px" }}>
                Our Gallery
              </h2>
              <div style={{ width:40, height:2, background:"linear-gradient(to right,#92400e,#d97706,transparent)", borderRadius:2, margin:"0 auto 16px" }} />
              <p className="text-gray-700 max-w-2xl mx-auto leading-relaxed">
                Glimpses of faith, fellowship, and celebration at St. Stephen's Church
              </p>
            </div>
          </FadeInOnScroll>

          <div className="relative">
            <div
              className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4"
              style={{
                WebkitMaskImage: 'linear-gradient(to bottom, black 50%, transparent 100%)',
                maskImage: 'linear-gradient(to bottom, black 50%, transparent 100%)'
              }}
            >
              {[gallery1,gallery2,gallery3,gallery4,gallery5,gallery6,gallery7,gallery8].map((img, i) => (
                <FadeInOnScroll key={i} distance={40} duration={950} delay={80 + i * 40}>
                  <div className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 aspect-square">
                    <img src={img} alt="Church" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </div>
                </FadeInOnScroll>
              ))}
            </div>
          </div>

          <FadeInOnScroll distance={40} duration={950} delay={400}>
            <div className="flex justify-center mt-8">
              <Link
                to="/parish/gallery"
                className="inline-flex items-center gap-3 bg-gradient-to-r from-amber-500 to-orange-500 text-white font-bold px-8 py-4 rounded-xl shadow-lg hover:shadow-2xl hover:from-amber-600 hover:to-orange-600 transition-all duration-300 transform hover:-translate-y-1"
              >
                <span>View Full Gallery</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                  <circle cx="8.5" cy="8.5" r="1.5" />
                  <path d="m21 15-5-5L5 21" />
                </svg>
              </Link>
            </div>
          </FadeInOnScroll>
        </div>
      </section>

      {/* QUICK CARDS */}
      <section className="relative w-full py-16">
        <div className="max-w-7xl mx-auto px-3 md:px-6 relative z-10">
          <section id="annmassbuttons"></section>
          <FadeInOnScroll distance={40} duration={950} delay={80}>
            <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-4 md:p-8 enhanced-card mb-8 border-0 md:border md:border-white/50">
              <div style={{ textAlign:"center", marginBottom:24 }}>
                <h2 style={{ fontFamily:"'Cormorant Garamond',Georgia,serif", fontSize:"clamp(26px,3.5vw,42px)", fontWeight:700, color:"#7c2d12", margin:"0 0 10px", lineHeight:1.1 }}>
                  Mass Timings
                </h2>
                <div style={{ width:36, height:2, background:"linear-gradient(to right,#92400e,#d97706,transparent)", borderRadius:2, margin:"0 auto" }} />
              </div>
              <div className="grid md:grid-cols-2 gap-8">
                <div className="bg-white/90 rounded-2xl p-4 md:p-6 enhanced-card border-0 md:border md:border-white/50">
                  <h3 className="text-xl font-bold text-amber-600 mb-4 text-center md:text-left">MASSES ON SUNDAY</h3>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex justify-between items-center gap-4"><span className="font-semibold flex-shrink-0">07:00 a.m.</span><span className="text-gray-600">(Konkani)</span></li>
                    <li className="flex justify-between items-center gap-4"><span className="font-semibold flex-shrink-0">08:30 a.m.</span><span className="text-gray-600">(English)</span></li>
                    <li className="flex justify-between items-center gap-4"><span className="font-semibold flex-shrink-0">10:00 a.m.</span><span className="text-gray-600">(English)</span></li>
                    <li className="flex justify-between items-center gap-4"><span className="font-semibold flex-shrink-0">04:00 p.m.</span><span className="text-gray-600">(Hindi)</span></li>
                    <li className="flex justify-between items-center gap-4"><span className="font-semibold flex-shrink-0">06:00 p.m.</span><span className="text-gray-600">(English)</span></li>
                  </ul>
                </div>
                <div className="bg-white/90 rounded-2xl p-4 md:p-6 enhanced-card border-0 md:border md:border-white/50">
                  <h3 className="text-xl font-bold text-amber-600 mb-4 text-center md:text-left">MASSES ON WEEKDAYS</h3>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex justify-between items-center gap-4"><span className="font-semibold flex-shrink-0">07:00 a.m.</span><span className="text-gray-600">(English)</span></li>
                    <li className="flex justify-between items-center gap-4"><span className="font-semibold flex-shrink-0">07:00 p.m.</span><span className="text-gray-600">(English)</span></li>
                  </ul>
                </div>
              </div>
            </div>
          </FadeInOnScroll>

          <div className="grid md:grid-cols-3 gap-8">
            <FadeInOnScroll distance={40} duration={950} delay={80}>
              <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-4 md:p-6 enhanced-card border-0 md:border md:border-white/50">
                <h3 className="font-bold text-xl md:text-lg text-amber-600 mb-3 text-center md:text-left">CONFESSIONS</h3>
                <p className="text-gray-700 text-base md:text-sm text-center md:text-left">
                  Every Saturday<br /><span className="font-semibold">6:15 pm to 7:00 pm</span>
                </p>
              </div>
            </FadeInOnScroll>

            <FadeInOnScroll distance={40} duration={950} delay={160}>
              <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-4 md:p-6 enhanced-card border-0 md:border md:border-white/50">
                <h3 className="font-bold text-xl md:text-lg text-amber-600 mb-3 text-center md:text-left">Parish Office Hours</h3>
                <p className="text-gray-700 text-base md:text-sm text-center md:text-left">
                  <span className="font-semibold">10 AM - 1 PM</span><br />
                  Call only between 10 AM - 1 PM<br />(Mon - Sat)
                </p>
              </div>
            </FadeInOnScroll>

            <FadeInOnScroll distance={40} duration={950} delay={240}>
              <Link
                to="/parish/clergy"
                className="block bg-white/80 backdrop-blur-sm rounded-2xl p-4 md:p-6 enhanced-card border-0 md:border md:border-white/50 cursor-pointer transition-all duration-300 hover:bg-white/90"
              >
                <h3 className="font-bold text-xl md:text-lg text-amber-600 mb-3 text-center md:text-left">CLERGY</h3>
                <ul className="text-gray-700 text-base md:text-sm space-y-1 text-center md:text-left">
                  <li>Fr Terence Murray (Parish Priest)</li>
                  <li>Fr Clarence Sequeira</li>
                  <li>Fr Tarsicius Fernandes (in residence)</li>
                  <li>Bishop Savio Fernandes (in residence)</li>
                </ul>
              </Link>
            </FadeInOnScroll>
          </div>
        </div>
      </section>
    </main>
  );
}